import React, { Component } from "react"
import { Link } from "react-router-dom"

import Button from "../Button/Button"
import SocialMedia from "../SocialMedia/SocialMedia"

import "./Footer.css"
import facebookIcon from "../images/facebook.svg"
import instagramIcon from "../images/instagram.svg"
import googleIcon from "../images/google-plus.svg"

const Footer = () => (
  <div className="footer">
    <div className="footer__bg"></div>

    <div className="footer__social-media">
      <SocialMedia />
    </div>
    <div className="footer__privacy-policy">
      <Link to="/privacypolicy">Privacy Policy</Link>
    </div>
    <div className="footer__copyright">
     {`© Copyright ${new Date().getFullYear()} Hibachi & You All Rights Reserved`}
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/Footer/Footer.js